import {
  Alert,
  AlertIcon,
  Box,
  Tabs,
  Tab,
  TabList,
  Flex,
  Heading,
  Link,
  Spacer,
  Text,
} from '@chakra-ui/react';
import React from 'react';
import { Link as RouterLink, useHistory } from 'react-router-dom';

import { colors } from 'packages/common-frontend/colors';
import { assignmentPagePaddingSide } from 'packages/loanProduct/ui/utils';

export const AssignmentHeader: React.FC<{
  children?: React.ReactNode;
  editMode: boolean;
}> = ({ children, editMode }) => {
  return (
    <Flex>
      <Heading as="h2">{editMode ? 'Edit Assignments' : 'Assignments'}</Heading>
      <Spacer />
      {children}
    </Flex>
  );
};

export const assignmentTabIndexes = {
  overview: 0,
  history: 1,
};

export const AssignmentTemplate: React.FC<{
  headerChildren?: React.ReactNode; // children for the top header, eg. buttons
  children: React.ReactNode; // children for the main content page
  selectedTab: keyof typeof assignmentTabIndexes;
  editMode?: boolean;
}> = ({ headerChildren, children, selectedTab, editMode = false }) => {
  const history = useHistory();

  return (
    <>
      <Box padding="30px 40px" background={colors.white}>
        <AssignmentHeader editMode={editMode}>
          {headerChildren}
        </AssignmentHeader>
      </Box>

      <Tabs
        variant="line"
        index={assignmentTabIndexes[selectedTab]}
        colorScheme="blue"
        background="white"
      >
        <TabList pl={assignmentPagePaddingSide}>
          <Tab
            onClick={() => {
              history.push('/assignments/summary');
            }}
          >
            Overview
          </Tab>
          <Tab onClick={() => history.push('/assignments/history')}>
            History
          </Tab>
        </TabList>
      </Tabs>

      <Box pl={assignmentPagePaddingSide} pr={assignmentPagePaddingSide}>
        {children}
      </Box>
    </>
  );
};

export const AssignmentHighlightBox = ({
  children,
}: {
  children: React.ReactChild | React.ReactChild[];
}) => {
  return (
    <Box
      background="white"
      borderRadius="8px"
      padding="32px"
      mb="32px"
      boxShadow="0px 1px 3px rgba(0, 0, 0, 0.1)"
    >
      {children}
    </Box>
  );
};

export const AssignmentIncompleteCurrentMasterLoanTapeSetAlert: React.FC<{
  selectedTab: keyof typeof assignmentTabIndexes;
}> = ({ selectedTab }) => {
  return (
    <Box height="100%">
      <AssignmentTemplate selectedTab={selectedTab}>
        <Alert status="warning" background="transparent">
          <Box>
            <Text mt="30px" mb="30px">
              All loan products for the organization must have a current master
              loan tape for the same reporting date and file version.
            </Text>
            <Flex>
              <AlertIcon />
              <Text>
                Please upload the necessary loan tapes in the{' '}
                <Link
                  as={RouterLink}
                  to="/manual-uploader"
                  style={{ textDecoration: 'underline' }}
                >
                  manual uploader
                </Link>
                .
              </Text>
            </Flex>
          </Box>
        </Alert>
      </AssignmentTemplate>
    </Box>
  );
};
